export default {
  label: {
    width: '100%',
  },
};
